import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  showPart1: boolean
  searchClassname: string;
  part1Classname: string;

  constructor() {
    this.showPart1 = true;
    this.searchClassname = '';
    this.part1Classname = 'part1-show';
  }

  openSearch() {
    this.showPart1 = false;
    this.part1Classname = 'part1-hide'
    this.searchClassname = 'search-open';
  }
  closeSearch() {
    this.showPart1 = true;
    this.part1Classname = 'part1-show'
    this.searchClassname = '';
  }
}
